<template>
  <div class="input_number_range">
    <el-input-number
      style="width: 80px"
      class="field"
      size="small"
      placeholder="请输入"
      controls-position="right"
      v-model="startNum"
      @change="changeNumHandle"
    />
    <span style="separator">~</span>
    <el-input-number
      style="width: 80px"
      class="field"
      size="small"
      placeholder="请输入"
      controls-position="right"
      v-model="endNum"
      @change="changeNumHandle"
    />
  </div>
</template>

<script>
export default {
  name: 'InputNumberRange',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      startNum: null,
      endNum: null
    }
  },
  model: {
    event: 'change',
    prop: 'value'
  },
  methods: {
    changeNumHandle() {
      const value = this.startNum === null && this.endNum === null ? [] : [this.startNum, this.endNum]
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.input_number_range {
  display: flex;
  align-items: center;
  .field {
    width: 100px;
  }
  .separator {
    margin: 0 10px;
  }
}
</style>
